<template>
  <div class="sample_group_container">
    <el-tabs v-model="activeName">
      <el-tab-pane label="样本命名" name="name">
        <div class="flex" style="justify-content: space-between;flex-wrap: wrap;">
          <div class="data_container">
            <div class="data_line header">
              <div v-for="(item, index) in props.configData.group_senior_mapping" :key="index" class="head_item">
                {{item.label }}
              </div>
            </div>
            <div class="data_line" v-for="(item, index) in raw_data" :key="index">
              <div class="line_left" v-for="(mapping, i) in props.configData.group_senior_mapping" :key="index">
                <el-input v-if="mapping.type === 'input'" placeholder="请输入内容"
                  v-model="raw_data[index][mapping.fixed_key || mapping.key]" :disabled="mapping.disabled"></el-input>
                <el-color-picker v-else-if="mapping.type === 'color'"
                  v-model="raw_data[index][mapping.fixed_key || mapping.key]"></el-color-picker>
              </div>
            </div>
          </div>
          <div style="flex: 1;">
            <div style="margin: 0 auto;display: table;">
              <p>更改完成后请点击 确定 按钮保存设置</p>
              <p>如需更改样本分组信息，请进入样本分组页面进行更改操作</p>
            </div>
          </div>
        </div>
      </el-tab-pane>
      <el-tab-pane label="样本分组" name="group">
        <div>
          <el-button type="primary" size="mini" @click="addhandle(0)" v-if="groupItems.length < 1">添加组</el-button>
          <el-divider v-if="groupItems.length < 1">暂无数据</el-divider>
          <div class="line_item flex" v-for="(item, index) in groupItems" :key="index">
            <div class="line_left flex">
              <div class="label">组名</div>
              <div class="value">
                <el-input placeholder="请输入内容" size="mini" v-model="groupItems[index].group"></el-input>
              </div>
            </div>
            <div class="line_right flex" style="flex: 1;">
              <div class="label">样本名</div>
              <div class="value" style="flex: 1;">
                <el-select style="width: 100%;" size="mini" v-model="groupItems[index].sample" multiple filterable
                  placeholder="请选择" @change="(val)=>handleSelect(index, val)" :disabled="!groupItems[index].group">
                  <el-option v-for="item in select_s" :key="item.value" :label="item.sampleNmae" :value="item.value"
                    :disabled="isOptionDisabled(item.value, index)">
                  </el-option>
                </el-select>
              </div>
            </div>

            <div class="line_btn_box">
              <el-button type="text" title="添加" @click="addhandle(index)">
                <el-icon>
                  <CirclePlus />
                </el-icon>
              </el-button>
              <el-button type="text" title="删除" @click="removehandle(index)">
                <el-icon style="color: #F56C6C;">
                  <Remove />
                </el-icon>
              </el-button>

            </div>

          </div>

        </div>

      </el-tab-pane>
    </el-tabs>
  </div>
</template>
<script setup>
  import { ref, defineProps, watch, onBeforeMount, onMounted, onBeforeUpdate, onUpdated, onBeforeUnmount, onUnmounted, defineEmits } from 'vue';
  import { ElMessage } from 'element-plus';

  const emit = defineEmits(['updateCompareGroup'])
  const props = defineProps(['rawData', 'configData']);


  const activeName = ref('name'); // 当前激活的分组名称
  const raw_data = ref([]); // 原始数据
  const select_s = ref([]); // 选项列表
  const groupItems = ref([]); // 用于存储分组项



  const handleData = function (rawData, mappings) {
    const sampleItem = mappings.find(item => item.fixed_key === 'sample');
    const groupItem = mappings.find(item => item.fixed_key === 'group');
    const samplenameItem = mappings.find(item => item.fixed_key === 'samplename');
    if (!sampleItem || !groupItem || !samplenameItem) return ElMessage.error('映射配置错误，请检查！');
    const result = { "groups": [], "sampleList": [] };
    const groupMap = new Map();
    rawData.forEach(item => {
      const group = item[groupItem.key];
      const sample = item[sampleItem.key];
      const sampleNmae = item[samplenameItem.key];
      result.sampleList.push({ label: sample, value: sample, sampleNmae: sampleNmae });
      // group 没有值，跳过
      if (!group) return;
      if (!groupMap.has(group)) {// 如果group不存在，则创建
        groupMap.set(group, { sample: [] });
      }
      groupMap.get(group).sample.push(sample);
    });
    groupMap.forEach((data, group) => {
      result.groups.push({
        group: group,
        sample: data.sample
      });
    });
    // 删除sampleList中的重复项（如果需要）
    result.sampleList = Array.from(new Set(result.sampleList.map(item => item.value))).map(value => result.sampleList.find(item => item.value === value));
    return result;
  };

  const isOptionDisabled = function (sampleCode, groupIndex) { // 检查选项是否被禁用
    for (let i = 0; i < groupItems.value.length; i++) {
      if (i === groupIndex) continue;
      if (groupItems.value[i].sample.includes(sampleCode)) {
        return true;
      }
    };
    return false;
  };

  const handleSelect = function (groupIndex, value) { // 处理样本选择
    //需要在每次变化时，确定没有重复选项，如果多个组里有重复选项，则根据groupIndex 找到对应组并删除重复选择
    let selectedSamples = value;
    let samplesToRemove = [];
    // 检查并移除重复的样本
    selectedSamples.forEach(sample => {
      for (let i = 0; i < groupItems.value.length; i++) {
        if (i === groupIndex) continue;
        if (groupItems.value[i].sample.includes(sample)) {
          ElMessage.error(`${sample} 已经在其他组中选择，已从当前组中移除！`);
          samplesToRemove.push(sample);
        };
      };
    });
    // 删除重复项
    groupItems.value[groupIndex].sample = groupItems.value[groupIndex].sample.filter(sample => !samplesToRemove.includes(sample));
  };

  const addhandle = function (index) {
    const newGroup = { group: '', sample: [] };
    groupItems.value.splice(index + 1, 0, newGroup);
  };

  const removehandle = function (index) {
    groupItems.value.splice(index, 1);
  };

  const updateDataWithGroup = function (originalData, groupedData, mapping) {
    // 创建分组映射，确保每个 sample 对应到 group
    const groupMap = groupedData.reduce((map, group) => {
      group.sample.forEach(companyCode => {
        map[companyCode] = group.group; // 每个样本的分组名称
      });
      return map;
    }, {});
    // 更新原始数据中的分组字段
    return originalData.map(item => {
      const updatedItem = { ...item };
      // 从 mapping.sample_id 获取原始数据中的公司代码
      const companyCode = updatedItem[mapping.sample_id];
      // 从 groupMap 获取分组，如果不存在则为空字符串
      updatedItem[mapping.group] = groupMap[companyCode] || ''; // 更新 group 字段
      return updatedItem;
    });
  };

  //更新原始数据中的分组信息
  /*  const updateGroupInDatas = function (rawData, updatedGroups, mappings) {
     const sampleItem = mappings.find(item => item.fixed_key === 'sample'); // 找到 sample 字段的映射配置
     const groupItem = mappings.find(item => item.fixed_key === 'group'); // 找到 group 字段的映射配置
     const samplenameItem = mappings.find(item => item.fixed_key === 'samplename'); // 找到 samplename 字段的映射配置
     if (!sampleItem || !groupItem || !samplenameItem) return ElMessage.error('映射配置错误，请检查！');
     // 从原始数据的第一个元素中提取字段名
     const key_obj = rawData.length > 0 ? Object.keys(rawData[0]).reduce((acc, key) => {
       acc[key] = "";  // 为每个字段提供一个默认值
       return acc;
     }, {}) : {};
     const groupMap = updatedGroups.reduce((map, group) => {
       group.sample.forEach(companyCode => {
         map[companyCode] = group.group; // 每个样本的分组名称
       });
       return map;
     }, {});
     // 遍历更新后的分组数据
     updatedGroups.forEach(updatedGroup => {
       const newGroup = updatedGroup.group; // 获取新的分组名称
       const updatedSampleCodes = updatedGroup.sample; // 获取更新后的样本代码列表
       // 遍历新分组的样本代码
       updatedSampleCodes.forEach(sampleCode => {
         // 检查原始数据中是否已有该样本代码
         const existingItem = rawData.find(item => item[sampleItem.key] === sampleCode);
         // 如果原始数据中没有该样本代码，添加一条新数据
         if (!existingItem) {
           // 使用动态生成的 key_obj 填充数据
           rawData.push({
             ...key_obj, // 保持原始数据字段结构
              [sampleItem.key]: sampleCode,
              [groupItem.key]: newGroup, // 更新分组
              [samplenameItem.key]: sampleCode, // 假设 samplename 与 sampleCode 相同
           });
         } else {
           // 如果原始数据中已存在该样本代码，更新它的分组
           existingItem[groupItem.key] = newGroup;
         }
       });
     });
     return rawData.map(item => {
       const updatedItem = { ...item };
       const companyCode = updatedItem[sampleItem.key];
       updatedItem[groupItem.key] = groupMap[companyCode] || ''; // 更新 group 字段
       return updatedItem;
     });
   }; */


  const updateGroupInDatas = (rawData, updatedGroups, mappings) => {
    const sampleItem = mappings.find(item => item.fixed_key === 'sample');
    const groupItem = mappings.find(item => item.fixed_key === 'group');
    const samplenameItem = mappings.find(item => item.fixed_key === 'samplename');

    if (!sampleItem || !groupItem || !samplenameItem) {
      ElMessage.error('映射配置错误，请检查！');
      return;
    };
    // 
    const invalidItems = rawData.filter(
      item => !item[samplenameItem.key] || item[samplenameItem.key].toString().trim() === ''
    );
    if (invalidItems.length > 0) {
      console.error('存在 samplename 为空的条目:', invalidItems);
      ElMessage.error(`存在 ${invalidItems.length} 个样本的别名为空，请检查！`);
      return [];
    };

    const keyTemplate = rawData[0] ? Object.keys(rawData[0]).reduce((acc, key) => {
      acc[key] = "";
      return acc;
    }, {}) : {};
    // 构建样本 => 分组映射表
    const groupMap = updatedGroups.reduce((map, group) => {
      group.sample.forEach(sampleCode => {
        map[sampleCode] = group.group;
      });
      return map;
    }, {});
    // 用 Map 优化查找效率
    const rawDataMap = new Map(rawData.map(item => [item[sampleItem.key], item]));
    // 遍历所有更新分组，更新或新增
    for (const [sampleCode, groupName] of Object.entries(groupMap)) {
      if (rawDataMap.has(sampleCode)) {
        // 已存在，更新 group
        rawDataMap.get(sampleCode)[groupItem.key] = groupName;
      } else {
        // 不存在，新增
        const newItem = {
          ...keyTemplate,
          [sampleItem.key]: sampleCode,
          [groupItem.key]: groupName,
          [samplenameItem.key]: sampleCode,
        };
        rawData.push(newItem);
        rawDataMap.set(sampleCode, newItem);
      }
    }
    // 最后确保所有 group 字段与映射表一致
    rawData.forEach(item => {
      const code = item[sampleItem.key];
      item[groupItem.key] = groupMap[code] || '';
    });
    return rawData;
  };

  const validateData = function (data, config) { // 检查分组的数量是否符合要求 
    if (data.length < 1) {
      ElMessage.error('请完善样本分组！');
      return false;
    };
    const { group_mapping, group_config: { min_count, max_count } } = config;
    for (let { group, sample } of data) {
      if (!group) {
        ElMessage.error(`分组名称不能为空，请修改后再保存！`);
        return false;
      };
      const length = sample.length;
      if (length === 0) {
        ElMessage.error(`分组 ${group} 不能为空，请修改后再保存！`);
        return false;
      };
      if ((min_count && length < min_count) || (max_count && length > max_count)) {
        ElMessage.error(`分组 ${group} 数量不符合配置要求，请修改后再保存！`);
        return false;
      };
    };
    return true;
  };

  const validateUniqueSamplename = function (rawData) { // 检查 samplename 是否唯一,检测对象是原始数据
    const sampleNames = new Set();
    for (let item of rawData) {
      const sampleName = item['samplename'];
      if (sampleNames.has(sampleName)) {
        ElMessage.error(`样本别名 ${sampleName} 不唯一，请修改后再保存！`);
        return false;
      }
      sampleNames.add(sampleName);
    };
    return true;
  };

  const update_raw_data = function (new_data, raw_data, mappings) { // 遍历格式化后的数据
    // 遍历格式化后的数据
    for (let i = 0; i < new_data.length; i++) {
      const updatedItem = new_data[i]; // 获取更新后的数据项
      const originalItem = raw_data[i]; // 获取原始数据项
      // 遍历映射配置
      for (let j = 0; j < mappings.length; j++) {
        const mapping_item = mappings[j];
        const key = mapping_item.fixed_key || mapping_item.key;
        // 如果在更新的数据项中存在对应字段，且该字段值发生变化
        if (updatedItem[key] !== originalItem[mapping_item.key]) {
          // 更新原始数据
          originalItem[mapping_item.key] = updatedItem[key];
        }
      }
    };
    return raw_data; // 返回更新后的原始数据
  };

  const updateHandle = function () { // 将数据返回给父组件
    console.log("更新数据", raw_data.value);

    const isValid = validateUniqueSamplename(raw_data.value);//校验样本别名唯一
    if (!isValid) return;
    const isNumValid = validateData(groupItems.value, props.configData);//校验分组的数量是否符合要求
    if (!isNumValid) return;
    const new_result = update_raw_data(raw_data.value, props.rawData, props.configData.group_senior_mapping);
    const newRawData = updateGroupInDatas(new_result, groupItems.value, props.configData.group_senior_mapping);
    console.log("更新后的数据", newRawData);
    // return
    if (newRawData && newRawData.length > 0) {
      emit('updateCompareGroup', newRawData);
    }
  };


  const format_data = function (raw_data, mappings) { // 格式化数据
    const formatted_data = [];
    for (let i = 0; i < raw_data.length; i++) {
      const item = raw_data[i];
      const new_item = {};
      for (let j = 0; j < mappings.length; j++) {
        const mapping_item = mappings[j];
        const key = mapping_item.fixed_key || mapping_item.key;
        new_item[key] = item[mapping_item.key];
      };
      formatted_data.push(new_item);
    };
    return formatted_data;
  };

  // 使用 watch 监听 props 的字段变化
  watch(() => props, (newData, oldData) => {
  });
  //组件即将挂载
  onBeforeMount(() => {
  });
  //组件已经挂载
  onMounted(() => {


    console.log("分组组件接受了哪些数据", props);

    const { groups, sampleList } = handleData(props.rawData, props.configData.group_senior_mapping);
    groupItems.value = groups;
    select_s.value = sampleList;
    const test_data = format_data(props.rawData, props.configData.group_senior_mapping);
    raw_data.value = test_data;

  });
  //组件即将更新
  onBeforeUpdate(() => {
  });
  //组件已经更新
  onUpdated(() => {
  });
  //组件即将卸载
  onBeforeUnmount(() => {
  });
  //组件已经卸载
  onUnmounted(() => {
  });
  defineExpose({
    updateHandle
  });
</script>
<style scoped>
  .sample_group_container .line_item {
    margin: 10px 15px;
  }

  .sample_group_container .flex {
    display: flex;
    justify-content: flex-start;
    align-items: center;
  }

  .sample_group_container .label {
    margin-right: 10px;
  }

  .sample_group_container .line_right .label {
    margin-left: 20px;
  }

  .sample_group_container .line_btn_box {
    padding-left: 20px;
  }

  .sample_group_container .data_container {
    width: 520px;
    max-width: 100%;
    max-height: 450px;
    overflow: auto;
  }

  .sample_group_container .data_line {
    display: flex;
    justify-content: space-between;
    align-items: center;
    gap: 10px;
    margin-bottom: 10px;
  }

  .sample_group_container .header {
    background-color: #eceef2;
    padding: 10px 0;
  }

  .sample_group_container .data_line .line_left,
  .sample_group_container .data_line .line_right,
  .sample_group_container .data_line .head_item {
    flex: 1;
  }
</style>